Sentry.init({
	dsn: 'https://fcd1f801d46d428c82b86ba3d32ec3ac@o242486.ingest.sentry.io/5284447',
	release: "0.2.2-prod",
	environment: "local",
});

import mobiscroll from './../public/js/mobiscroll.javascript.min';
import { AWSAuth, Navigation, Payment } from '@Services';
import App from '@App/App.svelte';

const app = new App({
	target: document.body,
});

window.app = app;
window.mobiscroll = mobiscroll;

function _sendVerificationCode(username) {
	AWSAuth.resend(username).then((response) => {
		if (response === undefined) {
			document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
		} else if (response.code === 'UserNotConfirmedException'){
			document.querySelector('.mbsc-note.mbsc-note-warning').style.display = 'block';
		} else {
			mobiscroll.alert({
				title: 'Por favor revisa tu correo.',
				message: 'Hemos re-enviado un correo de confirmación de e-mail a la dirección: ' + username,
				callback: () => {
					Navigation.goTo('account');
				},
			});
		}
	});
};
window._sendVerificationCode = _sendVerificationCode;

function _confirmationMessage(data) {
	AWSAuth.getUser().then(user => {
		if (typeof user === 'string') {
			Navigation.goTo('home');
			return;
    }
		let paymentInfo = {
			membershipType: 'yearly',
			amount: 2436.00,
			discountCode: '',
			tx: {
				paymentID: data.paymentID,
				payerID: data.paymentID,
			},
		};
		if ('recurrence' in data) {
			// Stripe payment
			let membershipType = 'yearly';
			if (data.recurrence === 'month') {
				membershipType = 'monthly';
			}
			paymentInfo = {
				membershipType: data.recurrence,
				amount: data.amount,
				discountCode: 'STRIPE',
				tx: {
					paymentID: data.paymentID,
					payerID: data.customerID,
				},
			};
		}
		const memberAttributes = Payment.getMemberInfo(user, paymentInfo);
		if (memberAttributes === false) {
			mobiscroll.alert({
				title: 'Membresía aplicada',
				message: 'Este pago ya ha sido aplicado a tu cuenta.',
				callback: () => {
					Navigation.goTo('account');
				},
			});
			return;
		}
		AWSAuth.updateMember(user, memberAttributes).then(response => {
			if ('recurrence' in data) {
				const recurrence = data.recurrence === 'month' ? 'mensual' : 'anual';
				mobiscroll.alert({
					title: 'Gracias por tu compra',
					message: 'Tu membresía ' + recurrence + ' ha sido activada.',
					callback: () => {},
				});
			}else{
				mobiscroll.alert({
					title: 'Gracias por tu compra',
					message: 'Tu membresía anual ha sido activada.',
					callback: () => {
						Navigation.goTo('account');
					},
				});
			}
		}).catch(error => console.error(error));
	}).catch(error => {
		console.error(error);
		mobiscroll.alert({
			title: 'Gracias por tu compra',
			// message: 'Recibirás un correo cuando hayamos activado tu membresía anual. Para cualquier duda o aclaración puedes visitar nuestra página de contacto.',
			message: error,
			callback: () => {
				// Navigation.goTo('home');
			},
		});
	});
};
window._confirmationMessage = _confirmationMessage;

export default app;
